import CurrentPlan from "components/CurrentPlan/index";
import PlanExpiry from "components/PlanExpiry/index";
import React, { useEffect, useState } from "react";
// import { URL } from "URL/url";
// import init, { IzWasm } from "Wasm/izwasm";
import "./billing.scss";

function IndividualBilling({ setChangePlan }) {
  // const [paymentStatus, setPaymentStatus] = useState("");
  const [paymentStatus] = useState("");
  const [isPlanExpired, setIsPlanExpired] = useState(false);

  const getPayment = async () => {
    try {
      
      // await init();
      // const wasmInstance = new IzWasm(URL);
      // const org = await wasmInstance.get_payment_status(
      //  localStorage.getItem("mail"),
      //  localStorage.getItem("name")
      // ) ; // (email,organization_name)
      // setPaymentStatus(org);
      // console.log("payment status", org);
    } catch (error) {
      console.error("error during get payment status", error);
    }
  };

  useEffect(() => {
    getPayment();

    // Check if plan is expired
    const checkPlanExpiry = () => {
      const expiryDateStr = sessionStorage.getItem("expirydate");

      if (expiryDateStr) {
        const expiryDate = new Date(expiryDateStr);
        const currentDate = new Date();

        // Set isPlanExpired to true if current date is past expiry date
        setIsPlanExpired(currentDate > expiryDate);
      } else {
        // If no expiry date is found, consider the plan as not expired
        setIsPlanExpired(false);
      }
    };

    checkPlanExpiry();

    // Check if we should automatically open the Change Plan component
    const shouldOpenChangePlan =
      sessionStorage.getItem("openChangePlanFromBilling") === "true";
    if (shouldOpenChangePlan) {
      // Remove the flag so it doesn't persist
      sessionStorage.removeItem("openChangePlanFromBilling");
      // Open the Change Plan component
      setChangePlan(true);
    }

    // Listen for the updateSettingsTab event to handle the case when already on Billing tab
    const handleUpdateSettingsTab = () => {
      const shouldOpenChangePlan =
        sessionStorage.getItem("openChangePlanFromBilling") === "true";
      if (shouldOpenChangePlan) {
        // Remove the flag so it doesn't persist
        sessionStorage.removeItem("openChangePlanFromBilling");
        // Open the Change Plan component
        setChangePlan(true);
      }
    };

    window.addEventListener("updateSettingsTab", handleUpdateSettingsTab);

    return () => {
      window.removeEventListener("updateSettingsTab", handleUpdateSettingsTab);
    };
  }, [setChangePlan]);

  return (
    <>
      {(!paymentStatus || isPlanExpired) && <PlanExpiry />}
      <CurrentPlan setChangePlan={setChangePlan} />
    </>
  );
}

export default IndividualBilling;
